import InfiniteScroll from 'react-infinite-scroll-component'
import cl from 'classnames'

import { Props } from './types'

const InfiniteScrollWrapper: React.FC<Props> = ({
	lengthData,
	functionNext,
	children,
	hasMore,
	scrollableTarget,
	endMessage,
	height,
	initialScrollY = 0,
	className,
	loader,
	scrollToTopClassName
}) => (
	<InfiniteScroll
		dataLength={lengthData} //This is important field to render the next data
		next={functionNext}
		hasMore={hasMore}
		className={cl(scrollToTopClassName, className)}
		height={height}
		initialScrollY={initialScrollY}
		loader={loader}
		scrollableTarget={scrollableTarget}
		endMessage={endMessage}
	>
		{children}
	</InfiniteScroll>
)
export default InfiniteScrollWrapper
